import MediaCounter from '@v4/common/components/molecules/MediaCounter/MediaCounter';

export default MediaCounter;
